"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetBox = exports.formatDate = exports.mapCategory = exports.createIntegrationElements = void 0;
function createIntegrationElements(tag, className, text, attribute) {
    const e = document.createElement(tag);
    if (className)
        e.classList.add(...className.split(' '));
    if (text && text !== '')
        e.innerHTML = text;
    if (attribute && Array.isArray(attribute))
        e.setAttribute(attribute[0], attribute[1]);
    return e;
}
exports.createIntegrationElements = createIntegrationElements;
function mapCategory(category) {
    switch (category) {
        case "SOCIAL_MEDIA":
            return "SOCIAL MEDIA";
        case "CRM_ERP_CMS":
            return "CRM/ERP/CMS";
        case "SUPPORT_TOOLS":
            return "SUPPORT TOOLS";
        case "SDKS_LIBRARIES":
            return "SDKS/LIBRARIES";
        default:
            return category;
    }
}
exports.mapCategory = mapCategory;
function formatDate(date) {
    return new Date(date * 1000).toLocaleDateString();
}
exports.formatDate = formatDate;
function resetBox(element, label) {
    if (element) {
        element.innerHTML = `<h4 class='integration__detail-label'>${label}</h4>`;
    }
}
exports.resetBox = resetBox;
